export const BASE_FIRST_ID = 'basefirst';

export const INCIDENT_FIELDS = {
  PRIMARY: 'primary_incident_type',
  INCIDENT_TYPES: 'incident_types',
};

export const INCIDENT_FIELDS_FOR_WATCHING = [
  `base.${INCIDENT_FIELDS.PRIMARY}`,
  `base.${INCIDENT_FIELDS.INCIDENT_TYPES}`,
];
